export default __webpack_public_path__ + "static/media/review17.be1859e8.jpg";